export const actions = {
    async nuxtServerInit({ dispatch }) {
        const start = Date.now();

        this.$axios.setHeader("Accept-Language", this.app.i18n.localeProperties.code);
        await Promise.allSettled([
            dispatch("collections/init"),
            dispatch("pages/init"),
            dispatch("globalvars/getInstaPosts"),
            dispatch("globalvars/getMainMenu"),
            dispatch("globalvars/getBanner"),
            dispatch("globalvars/getProductBlocks"),
        ]);

        const elapsed = Date.now() - start;
        if (elapsed > 2000) {
            console.warn(`[initLoader] slow: ${elapsed}ms`);
        }
    },
};
